import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
  numberFormat,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";
import catet_down from "../../../../src/Assets/Images/caret-down.png"

import {
  searchAttendance,
  searchAttendancePage,
} from "../../../Helpers/apiCalls/Reports/DailyAttendanceApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import Footer from "../../../Components/Footer/Footer";

export default function EmployeeHours() {
  const { id } = useParams();
  let navigate = useNavigate();
  const { state } = useLocation();

  const [inactive, setInactive] = useState(true);
  const [filterConfig, setFilterConfig] = useState({
    tab: "braddex",
    branch_id: id ? id : "",
    date_from: state?.date ? "" : new Date(),
    date_to: state?.date ? "" : new Date(),
    date: state?.date ? state.date : "",
    by_employees: state?.by_employees ? state.by_employees : true,
    group_branch: state ? "" : "N",
  });
  const [showLoader, setShowLoader] = useState(false);
  const [sales, setSales] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const today = Moment().format("MM/DD/YYYY");
  const [employees, setEmployees] = useState([]);

  const xlsxHeaders = [
    "NAME",
    "REGULAR WORKING HOURS",
    "UNDERTIME HOURS",
    "OVERTIME HOURS",
    "WORKING HOURS",
  ];

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={() => handleView(row)}
      >
        View
      </button>
    );
  }
  function handleView(row) {
    var from =
      filterConfig.date_from !== ""
        ? filterConfig.date_from
        : filterConfig.date;
    var to =
      filterConfig.date_to !== "" ? filterConfig.date_to : filterConfig.date;
    var datefrom = Moment(from).format("MM-DD-YYYY");
    var dateto = Moment(to).format("MM-DD-YYYY");
    navigate(
      "/dailyattendancelist/view/employee/" +
        row.employee_id +
        "/" +
        datefrom +
        "/" +
        dateto +
        "/" +
        row.shop,
      "_blank"
    );
  }

  function handleExport() {
    const rows = excelData;

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
    XLSX.writeFile(workbook, "Attendance.xlsx", { compression: true });
  }

  async function fetchEmployees() {
    if (filterConfig.tab === "braddex") {
      const response = await getAllEmployees();
      if (response.error) {
        setEmployees([]);
      } else {
        let result = response.data.data.map((data) => {
          var employee = data;
          employee.label = data.first_name + " " + data.last_name;
          employee.value = data.id;
          return employee;
        });
        setEmployees([{ label: "All Employees", value: "" }, ...result]);
      }
    }
  }

  async function fetchData() {
    setShowLoader(true);
    setSales([]);
    setExcelData([]);

    if (state) {
      if (filterConfig.tab === "braddex") {
        const response = await searchAttendance(filterConfig);

        if (response.error) {
        } else {
          var allBills = response.data.data.map((bill) => {
            var info = bill;
            info.time_in = bill.attendance_entries[0]?.time_in;
            info.time_out = bill.attendance_entries[0]?.time_out;
            info.total_hours = numberFormat(parseInt(bill.total_minutes) / 60);
            info.undertime = numberFormat(parseInt(bill.undertime) / 60);
            info.overtime = numberFormat(parseInt(bill.overtime) / 60);
            info.regular_working_hours = numberFormat(
              bill.regular_working_hours
            );
            info.shop = "braddex";
            return info;
          });
          setSales(allBills);

          var excel = allBills.map((bill) => {
            var info = {};
            info.employee_name = bill.employee_name;
            info.regular_working_hours = bill.regular_working_hours;
            info.undertime = bill.undertime;
            info.overtime = bill.overtime;
            info.total_hours = bill.total_minutes;
            return info;
          });
          setExcelData(excel);
        }
        setShowLoader(false);
      }
    } else {
      if (filterConfig.tab === "braddex") {
        const response = await searchAttendancePage(filterConfig); //NEW API

        if (response.error) {
        } else {
          const allBills = response.data.data.map((bill) => {
            var info = bill;
            info.total_hours = numberFormat(bill.total_hours);
            info.undertime = numberFormat(bill.undertime);
            info.overtime = numberFormat(bill.overtime);
            info.regular_working_hours = numberFormat(
              bill.regular_working_hours
            );
            info.shop = "braddex";
            return info;
          });
          setSales(allBills);

          const excel = allBills.map((bill) => {
            var info = {};
            info.employee_name = bill.employee_name;
            info.regular_working_hours = bill.regular_working_hours;
            info.undertime = bill.undertime;
            info.overtime = bill.overtime;
            info.total_hours = bill.total_hours;
            return info;
          });
          setExcelData(excel);
        }
        setShowLoader(false);
      }
    }
  }

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    fetchData();
  }, [filterConfig]);

  function handleAddChange(e) {
      navigate("/attendance/" + e.target.value);
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={state ? "STORE REPORTS" : "PAYROLL"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={10}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ATTENDANCE </h1>
          </Col>
          <Col lg={2} className="mt-2 mt-lg-0">
              <div className="PO-filters">
              <Form.Select
                  // className="add-select"
                  className="date-filter force-width w-full"
                  style={{ backgroundColor: "var(--primary-color)", color: "white"}}
                  onChange={(e) => handleAddChange(e)}
              >
                  <option value="" hidden selected>
                      Add
                  </option>
                  <option value="manual">Manual</option>
                  <option value="upload">Upload</option>
              </Form.Select>
              </div>
          </Col>
        </Row>
        {state && (
          <Row className="mb-4">
            <Col xs={6}>
              <h5 className="page-subtitle">
                {" "}
                {new Date(filterConfig.date).toLocaleDateString("en-us", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}{" "}
              </h5>
            </Col>
          </Row>
        )}

        <div className="tab-content">
          {/* filters */}
          {!state && (
            <>
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Employee"
                styles={selectDropdownStyle}
                // value={branch}
                options={employees}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return { ...prev, employee_id: e.value };
                  });
                }}
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_from}
                name="date_from"
                placeholderText={today}
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date };
                  });
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
              </Col>
              <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_to}
                name="date_to"
                placeholderText={today}
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date };
                  });
                }}
                fixedHeight
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-2" />
          </>
          )}

          <div className="below">
            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "NAME",
                "REGULAR WORKING HOURS",
                "UNDERTIME HOURS",
                "OVERTIME HOURS",
                "WORKING HOURS",
              ]}
              headerSelector={[
                "-",
                "employee_name",
                "regular_working_hours",
                "undertime",
                "overtime",
                "total_hours",
              ]}
              tableData={sales}
              ViewBtn={(row) => ViewBtn(row)}
              showLoader={showLoader}
            />
          </div>
          <div className="mb-2" />
        </div>
        <div className="mb-3" />
        <Row>
            <Col lg={10} className="mt-3 mt-lg-0"></Col>
            <Col lg={2} className="mt-3 mt-lg-0">
              <div className="PO-filters">
                <button
                    type="button"
                    className="primary-btn"
                    onClick={handleExport}
                >
                    <span className="me-2">
                        <img
                            width={20}
                            height={20}
                            src={downloadIcon} alt=""
                        ></img>
                    </span>
                    Download
                </button>
              </div>
          </Col>
        </Row>
      </div>
      <Footer/>
    </div>
  );
}
